import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AppProvider } from "@/contexts/AppContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Booking from "@/pages/Booking";
import Track from "@/pages/Track";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import AuthPage from "@/pages/AuthPage";
import AdminDashboard from "@/pages/AdminDashboard";
import LegalPage from "@/pages/LegalPage";
import News from "@/pages/News";
import Forms from "@/pages/Forms";

function App() {
    return (
        <AppProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/forms" element={<Forms />} />
                            <Route path="/news" element={<News />} />
                            <Route path="/booking" element={<Booking />} />
                            <Route path="/track" element={<Track />} />
                            <Route path="/gallery" element={<Gallery />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/admin/login" element={<AuthPage mode="login" admin />} />
                            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
                            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
                            <Route path="/terms" element={<LegalPage kind="terms" />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </Layout>
                    <Toaster position="top-right" richColors />
                </BrowserRouter>
            </AuthProvider>
        </AppProvider>
    );
}

export default App;
